import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import store from './store'
import VuexRouterSync from 'vuex-router-sync'
import { config } from '@/../app.config'
import _ from 'lodash'
import Amplify, * as AmplifyModules from '@/types/amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from '@/aws-exports'
import VueCookies from 'vue-cookies'
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers'
//import AWN from 'awesome-notifications'
//import VueAWN from 'vue-awesome-notifications'
import Auth from '@aws-amplify/auth'
import { IAuthToken } from './store/modules/auth'
import { EventBus } from './utils/eventbus'
import VModal from 'vue-js-modal'
// force build


export interface IConfig {
  [key: string]: IConfigProperties; // Index Signature
  env: IConfigProperties;
}

interface IConfigProperties {
  [key: string]: any;
  apiEndpoint: string;
  matchupEndpoint: string;
  personalisedEndpoint: string;
  historyEndpoint: string;
  userCacheEndpoint: string;
  newsEndpoint: string;
  debug: boolean;
  dsn: string;
  heapEnv: string;
  mqttPath: string;
  mqttRegion: string;
}

//@ts-ignore
Sentry.init({ dsn: config.dsn });

//@ts-ignore
window.heap=window.heap||[]
//@ts-ignore
heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement('script');r.type='text/javascript',r.async=!0,r.src='https://cdn.heapanalytics.com/js/heap-'+e+'.js';var a=document.getElementsByTagName('script')[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=['addEventProperties','addUserProperties','clearEventProperties','identify','resetIdentity','removeEventProperty','setEventProperties','track','unsetEventProperty'],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
//@ts-ignore
heap.load(config.heapEnv);

Amplify.configure({
  ...awsconfig, 
  Analytics: {
    disabled: true
  }
})

Vue.use(AmplifyPlugin, AmplifyModules, VueCookies)

Vue.use(VModal)

//@ts-ignore
$cookies.config('7d','','',true)

Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: config.mqttRegion,
  aws_pubsub_endpoint: config.mqttPath,
}));

Vue.config.devtools = config.debug

axios.interceptors.request.use(async function (options) {
  const data = await Auth.currentAuthenticatedUser()

  const tokens = {
    access: _.get(data, 'signInUserSession.accessToken.jwtToken'),
    id: _.get(data, 'signInUserSession.idToken.jwtToken')
  } as IAuthToken
  
  options.headers.Authorization = `Bearer ${tokens.access}`
  options.headers['X-Identity-Token'] = tokens.id
  return options;
}, function (error) {
  //console.log('Request error: ', error)
  return Promise.reject(error)
});

VuexRouterSync.sync(store, router)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#root');

/* TSEVO CODE */
let globalWindow = window as any;

globalWindow.gidxServiceSettings = function() { 
  globalWindow.gidxBuildSteps = false; 
  globalWindow.gidxContainer = '#GIDX_ServiceContainer'
}

globalWindow.gidxErrorReport = function(error: number, errorMsg: string) {
  //Error handler
  console.log('gidxErrorReport ->', error, errorMsg)
  //@ts-ignore
  Sentry.captureException(`${error}: ${errorMsg}`)
  EventBus.$emit('paymentSessionError')
}

globalWindow.gidxNextStep = function() {
  //payment complete
  console.log('paymentSessionComplete ->', arguments)
  EventBus.$emit('paymentSessionComplete')
}

globalWindow.gidxServiceStatus = function (service: object, action: string, json: object) {
  //called at each step of the process
  console.log('gidxServiceStatus ->', action, json)
  EventBus.$emit('paymentSessionStarted')
}

setTimeout(() => {
  window.scrollTo(0, 1);
}, 0);